(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('updatesoon', {
            parent: 'app',
            url: '/updatesoon',
            data: {
                authorities: [],
                pageTitle: 'global.menu.suggestions'
            },
            views: {
                'content@': {
                    templateUrl: 'app/update-soon/update-soon.html',
                    controller: 'UpdateSoonController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('news-update', {
            parent: 'app',
            url: '/news-update/{value}',
            data: {
                authorities: [],
                pageTitle: 'global.menu.suggestions'
            },
            views: {
                'content@': {
                    templateUrl: 'app/update-soon/news.html',
                    controller: 'UpdateSoonController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
